import React from "react";
import { NovaThinkingLoader } from "./NovaChatOptions";

const NovaAiInitialLoader = () => {
  return <NovaThinkingLoader />;
};

export default NovaAiInitialLoader;
